import { AssetSubscriptionDto, AssetSubscriptionReferenceDto } from "@/core/api/generated/v1";

/** Any entity DTO type according to @type EntityFormType */
export type AssetSubscriptionDtoAny = AssetSubscriptionDto | AssetSubscriptionReferenceDto;

/** All entity DTO types according to @type EntityFormType */
export type AssetSubscriptionDtoAll = AssetSubscriptionDto & AssetSubscriptionReferenceDto;

export class AssetSubscriptionMapper {}
